import { render, staticRenderFns } from "./EditSupplierComponent.vue?vue&type=template&id=4de8202a"
import script from "./EditSupplierComponent.vue?vue&type=script&lang=js"
export * from "./EditSupplierComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports